(function () {
  'use strict';

  var SELECTOR = '[data-rvrn-community-review]';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function initSection(section) {
    if (section.dataset.rvrnInit) return;
    section.dataset.rvrnInit = 'true';

    var track = section.querySelector('[data-rvrn-cr-track]');
    var autoplay = section.dataset.autoplay !== 'false';

    if (!autoplay || reduceMotion.matches) {
      section.classList.add('is-static');
    }

    /* ---- seamless marquee: clone original cards once ---- */
    if (track && !track.dataset.cloned) {
      track.dataset.cloned = 'true';
      var cards = Array.prototype.slice.call(track.children);
      cards.forEach(function (card) {
        track.appendChild(card.cloneNode(true));
      });
    }

    /* ---- review text: show View More only when clamped ---- */
    var comments = Array.prototype.slice.call(section.querySelectorAll('[data-rvrn-cr-comment]'));

    function checkOverflow() {
      comments.forEach(function (el) {
        var btn = el.nextElementSibling;
        if (!btn || !btn.matches('[data-rvrn-cr-more]')) return;
        var expanded = el.classList.contains('is-expanded');
        el.style.webkitLineClamp = 'unset';
        var fullH = el.scrollHeight;
        el.style.webkitLineClamp = '';
        var clamped = fullH > el.clientHeight + 2;
        if (expanded && !clamped) {
          el.classList.remove('is-expanded');
          btn.textContent = 'View More';
        }
        btn.hidden = !clamped;
      });
    }

    /* ---- event delegation: View More / Show Less ---- */
    if (track) {
      track.addEventListener('click', function (event) {
        var btn = event.target.closest('[data-rvrn-cr-more]');
        if (!btn || btn.hidden) return;
        var comment = btn.previousElementSibling;
        if (!comment || !comment.matches('[data-rvrn-cr-comment]')) return;
        var expanded = comment.classList.toggle('is-expanded');
        btn.textContent = expanded ? 'Show Less' : 'View More';
      });
    }

    checkOverflow();

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkOverflow, 150);
    });
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector ? event.target.querySelector(SELECTOR) : null;
    if (section) initSection(section);
  });
})();
